import { FC, useContext } from "react";
import Summary, { ContentPriceCell, LabelCell, NormalRow } from "../../group_travel/components/Summary";
import { BindContext } from "../BindQuote";
import AuGroupBusinessFormStepNavigation from "../../group_travel/Form/CreateQuoteStepNavigation";
import { CommonTable } from "../../event_public_liability/components/CommonTable";
import SummarySection from "../../../components/forms/SummarySection";
import { useTranslation } from "react-i18next";
import { GroupPersonalAccidentBindState } from "./types";
import GroupTravelHeading from "../../group_travel/components/Heading";

interface SummaryQuoteProps {
  onNext: VoidFunction | null;
  onPrevious: VoidFunction | null;
}
interface Props {
  state: any;
  editProposalDetailsLink: string;
  t: any;
}
const formatToAddressLines = (state: GroupPersonalAccidentBindState): string[] => {
  // address in expected  format
  return [
    `${state.streetNumber} ${state.unitNumber} ${state.floorNumber} ${state.streetName},\n`,
    `${state.suburb}, ${state.state}, ${state.postalCode}`,
  ];
};

export const SummarySections: FC<Props> = ({ state, t, editProposalDetailsLink }) => {
  return (
    <SummarySection link={editProposalDetailsLink} name={t("summaryLabels.policyholderDetails")}>
      {/* edit proposer summary section */}
      <CommonTable className="w-full mt-2 table-fixed">
        <NormalRow>
          <LabelCell>{t("summaryLabels.policyholdersName")}</LabelCell>
          <ContentPriceCell>{state.policyHoldersName}</ContentPriceCell>
        </NormalRow>
        <NormalRow>
          <LabelCell>{t("summaryLabels.policyholdersAddress")}</LabelCell>
          <ContentPriceCell>{formatToAddressLines(state)}</ContentPriceCell>
        </NormalRow>
        <NormalRow>
          <LabelCell>{t("summaryLabels.businessNumber")}</LabelCell>
          <ContentPriceCell>{state.australiaBusinessNo}</ContentPriceCell>
        </NormalRow>
      </CommonTable>
    </SummarySection>
  );
};

const ProposerSummary: React.FC<SummaryQuoteProps> = ({ onPrevious, onNext }) => {
  const { state } = useContext(BindContext);
  const { t } = useTranslation("pages", { keyPrefix: "groupPersonalAccident.newProduct" });

  return (
    <>
      <div className="container-flow flex-grow">
        <GroupTravelHeading title={t("summaryLabels.title")} alt="GroupPersonalAccident" className="pb-0" />
        <Summary
          renderSummarySection={<SummarySections t={t} state={state} editProposalDetailsLink={"/au/group_personal_accident/bind/proposer-details"} />}
          state={state}
        />
      </div>
      <AuGroupBusinessFormStepNavigation onNext={onNext} onBack={onPrevious} />
    </>
  );
};

export default ProposerSummary;
